import { AppWindow, Layers, Sparkles, Boxes, ArrowUpRight } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { Reveal, Overline } from "./Reveal";

const ICONS = [AppWindow, Layers, Sparkles, Boxes];

export default function Services() {
  const { t } = useLang();
  const items = t.services.items;

  return (
    <section id="services" className="relative py-28 md:py-40">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-8 items-end mb-16">
          <div className="lg:col-span-7">
            <Reveal><Overline>{t.services.overline}</Overline></Reveal>
            <Reveal delay={0.05}>
              <h2 className="font-head font-bold tracking-tighter text-ink text-[clamp(2.25rem,5vw,4.5rem)] leading-[0.95] mt-5">
                {t.services.title}
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.1} className="lg:col-span-5">
            <p className="text-base md:text-lg text-ink-2 leading-relaxed">{t.services.subtitle}</p>
          </Reveal>
        </div>

        <div className="grid grid-cols-12 gap-5 auto-rows-[minmax(220px,auto)]">
          {items.map((item, i) => {
            const Icon = ICONS[i];
            const span =
              i === 0 ? "col-span-12 md:col-span-8 md:row-span-2" :
              i === 3 ? "col-span-12 md:col-span-8" :
              "col-span-12 md:col-span-4";
            const big = i === 0;
            return (
              <Reveal
                key={i}
                delay={i * 0.08}
                className={`${span} group relative h-full rounded-2xl border border-line hover:border-line-hover bg-bg-2/50 p-8 md:p-10 overflow-hidden transition-colors duration-500`}
                data-testid={`service-card-${i}`}
              >
                <div className="pointer-events-none absolute -right-16 -top-16 h-48 w-48 rounded-full bg-brand/0 group-hover:bg-brand/10 blur-3xl transition-colors duration-700" />
                <div className="relative flex flex-col h-full">
                  <div className="flex items-start justify-between">
                    <div className="inline-flex h-12 w-12 items-center justify-center rounded-xl border border-line bg-bg text-brand group-hover:border-brand transition-colors duration-500">
                      <Icon className="h-6 w-6" />
                    </div>
                    <span className="font-mono text-xs tracking-widest text-ink-muted">{item.tag}</span>
                  </div>
                  <h3 className={`font-head font-bold text-ink tracking-tight mt-auto pt-10 ${big ? "text-3xl md:text-4xl" : "text-2xl"}`}>
                    {item.title}
                  </h3>
                  <p className={`text-ink-2 leading-relaxed mt-4 ${big ? "text-base md:text-lg max-w-lg" : "text-sm"}`}>
                    {item.desc}
                  </p>
                  {big && (
                    <div className="mt-8 inline-flex items-center gap-2 text-brand text-sm font-medium">
                      <span className="h-px w-8 bg-brand" />
                      <ArrowUpRight className="h-4 w-4" />
                    </div>
                  )}
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
